module.exports = __webpack_public_path__ + "static/media/fortoyningsbolter.736f2aa9.png";